import { Logout } from '@mui/icons-material';
import { Button, Divider } from '@mui/material';
import { useCandidateAuth } from 'features/auth';
import { useTranslation } from 'react-i18next';

export default function SignOutButton() {
    const { t } = useTranslation('auth');
    const { logout, isAuthenticated } = useCandidateAuth();

    if (!isAuthenticated) {
        return null;
    }

    return (
        <>
            <Divider sx={{ my: 5 }} />
       
            <Button variant="outlined"
                color="primary"
                startIcon={ <Logout /> }
                fullWidth
                onClick={ logout }
            >
                { t('logout') }
            </Button>
        </>
    );
}
